import { AfterViewInit, Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DeleteSimulationService } from '../delete-simulation.service';

@Component({
	selector: 'app-delete-simulation-table',
	templateUrl: './delete-simulation-table.component.html',
	styleUrls: ['./delete-simulation-table.component.css']
})
// --- Component Description ---
// Table component for displaying and selecting simulations for deletion. Handles row click/double-click and subscribes to filtered simulations.
export class DeleteSimulationTableComponent implements OnInit, AfterViewInit {
	@ViewChild(DataTableDirective) dtElement: DataTableDirective;
	dtOptions: DataTables.Settings = {
		pagingType: 'simple_numbers',
		pageLength: 5,
		order: [[0, 'asc']],
		lengthMenu: [[5, 10, 25], [5, 10, 25]],
		autoWidth: true,
		language: {
			emptyTable: 'No simulations found',
		}
	};
	dtTrigger: Subject<any> = new Subject<any>();
	isDtInitialized = false;

	simulations: any[] = [];
	selectedSimulation: any = null;
	clickTimeout: any = null;

	// --- Private Properties ---
	private filteredSimulationsSub: any;

	constructor(private deleteSimulationService: DeleteSimulationService) { }

	ngOnInit(): void {
		this.filteredSimulationsSub = this.deleteSimulationService.filteredSimulations$.subscribe(simulations => {
			this.simulations = simulations;
			this.selectedSimulation = null;
			this.deleteSimulationService.setSelectedSimulation(null);
			if (this.isDtInitialized && this.dtElement) {
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.dtTrigger.next();
				});
			}
		});
	}

	onRowClick(sim: any) {
		if (this.clickTimeout) {
			clearTimeout(this.clickTimeout);
			this.clickTimeout = null;
		}
		this.clickTimeout = setTimeout(() => {
			this.selectedSimulation = sim;
			this.deleteSimulationService.setSelectedSimulation(sim);
			this.clickTimeout = null;
		}, 200);
	}


	ngAfterViewInit(): void {
		this.isDtInitialized = true;
		this.dtTrigger.next();

		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
			dtInstance.on('page.dt length.dt', () => {
				setTimeout(() => {
					this.selectedSimulation = null;
					this.deleteSimulationService.setSelectedSimulation(null);
				}, 0);
			});
		});
	}

	ngOnDestroy(): void {
		if (this.filteredSimulationsSub) {
			this.filteredSimulationsSub.unsubscribe();
		}
		this.dtTrigger.unsubscribe();
	}
}